<mat-card class="dialog-card">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar flex flex-row items-center justify-between" color="accent">
      <h1 class="dialog-card-title">
        {{
          data.favoriteView?.id
            ? ('FAVORITE_VIEW.FORM.EDIT_FAVORITE_VIEW' | translate) + ' - ' + data.favoriteView.name
            : data.favoriteView?.name
              ? ('FAVORITE_VIEW.FORM.DUPLICATE_FAVORITE_VIEW' | translate) + ' - ' + data.favoriteView.name
              : ('FAVORITE_VIEW.FORM.CREATE_FAVORITE_VIEW' | translate)
        }}
      </h1>
      <button (click)="dialogRef.close()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>

  <mat-card-content class="dialog-card-content h-[600px]">
    <iot-platform-ui-favorite-view-form
      [favoriteView]="data.favoriteView"
      [currentFilters]="data.filters"
      [masterView]="data.masterView"
      [createForBusinessProfile]="data.createForBusinessProfile"
      (saveForm)="save($event)"
      (cancelForm)="dialogRef.close()"
    />
  </mat-card-content>
</mat-card>
